<template>
    <footer class="footer bg-default">
        <div class="container">
            <!-- Simple links section -->
            <div class="row pt-4">
                <div class="col-lg-6 col-md-6 mb-4 mb-md-0">
                    <h5 class="text-white">Zwapit</h5>
                    <p class="text-white opacity-8 mb-3">Swap your driving test appointments quickly and easily with our mobile app.</p>
                    <div class="mb-3">
                        <base-button tag="a" href="#" type="info" size="sm" class="btn-icon mr-2">
                            <img class="store-img-sm" src="https://img.icons8.com/?size=100&id=30840&format=png&color=FFFFFF" alt="">
                            <span class="btn-inner--text">App Store</span>
                        </base-button>
                        <base-button tag="a" href="#" type="primary" size="sm" class="btn-icon">
                            <img class="store-img-sm" src="https://img.icons8.com/?size=100&id=22982&format=png&color=FFFFFF" alt="">
                            <span class="btn-inner--text">Google Play</span>
                        </base-button>
                    </div>
                </div>
            </div>
            
            <hr class="border-white opacity-3">
            
            <!-- Copyright section -->
            <div class="row align-items-center justify-content-md-between py-4">
                <div class="col-md-12 text-center">
                    <div class="copyright text-white opacity-8">
                        &copy; {{year}} Zwapit. All rights reserved.
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'starter-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style lang="scss">
.footer {
    padding: 4rem 0;
    background: linear-gradient(150deg, #015cbe 15%, #017cfe 70%, #56a8fe 94%) !important;
}

.opacity-8 {
    opacity: 0.8;
}

.links-vertical {
    padding: 0;
    list-style: none;
    
    li a {
        text-decoration: none;
        transition: all 0.3s ease;
        
        &:hover {
            opacity: 1;
            text-decoration: none;
        }
    }
}

.store-img {
    width: 30px !important;
    height: 30px !important;
}

.store-img-sm {
    width: 20px !important;
    height: 20px !important;
}
</style>
